import styled from 'styled-components'
import { customMedia } from '../../utils/breakpoints'

export const SectionCard = styled.div`
    background-color: ${props => props.theme.services4u.background};
` 
export const ContentCards = styled.div`
    margin: 0 9.6rem;
    display: block;
    justify-content: center;
    
    ${customMedia.lessThan('md')`
        margin: 0;
        display: block;
    `}

    ${customMedia.lessThan('xs')`
        margin: 0 0 0 16px;
    `}

    ${customMedia.greaterThan('lg')`
        max-width: 1366px;
        margin: 0 auto;
    `}
`
export const TitleSectionCards = styled.h2`
    font-size: 40px;
    color: ${props => props.theme.services4u.titleSection};
    font-weight: bold;
    letter-spacing: -1px;

    ${customMedia.lessThan('md')`
        font-size: 24px;
        padding-top: 0
    `}
`
export const ContainerCardsExame = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding-top: 46px;

    >:nth-child(1){
        display: none;
    }

    ${customMedia.lessThan('md')`
        >:nth-child(1){
            display: block;
        }
        >:nth-child(n+2){
            display: none;
        }
    `}

    ${customMedia.lessThan('md')`
        display: block;
        flex-wrap: nowrap;
    `}
`

export const MainContent = styled.div`
    font-family: ${props => props.theme.font};
    padding: 48px 0 40px 135px;

    ${customMedia.greaterThan('lg')`
      max-width: 1366px;
      margin: 0 auto;
    `}

    ${customMedia.lessThan('md')`
      padding: 48px 0 40px 144px;
    `}

    ${customMedia.lessThan('sm')`
      padding: 54px 0 40px 94px;
    `}    

    ${customMedia.lessThan('xs')`
      padding: 40px 0 40px 0;
    `}
`

export const ExameCards = styled.div`
    margin-bottom: 24px;
    width: 535px;
    height: 189px;
    border: 0.903716px solid rgba(22, 22, 22, 0.08);
    background-color: #FEFEFE;
    border-radius: 7.22973px;

    ${customMedia.lessThan('md')`
        max-width: 253px;
        height: 415px;
        margin-right: 15px
    `}

    ${customMedia.lessThan('xs')`
        width: 222px;
    `}

`
export const Division = styled.div`
    display: flex;
    margin: 14px;

    ${customMedia.lessThan('md')`
        display: block;
        margin: 0;
    `}
`
export const DivFlex = styled.div`
    padding: 0 0 0 21px;

    ${customMedia.lessThan('md')`
        padding: 0 21px 0 21px;
    `}
`
export const ImgCard = styled.img`
    border-radius: 7px;
    width: 216px;
    height: 153px;

    ${customMedia.lessThan('md')`
        border-radius: 30px;
        width: 209px;
        height: 180px;    
        padding: 21px;
    `}

    ${customMedia.lessThan('xs')`
        width: 184px;
        height: 158px;
    `}

    
`
export const PreTitle  = styled.p`
    color: ${props => props.theme.services4u.title};
    font-size: 12px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    font-weight: bold;
    line-height: 133%;

    ${customMedia.lessThan('md')`
        width: 100%;
        font-size: 9px
    `}
`
export const Title = styled.h3`
    font-weight: bold;
    color: ${props => props.theme.services4u.header};
    font-size: 18px;
    padding-top: 7px;
`
export const Text = styled.p`
    width: 267.5px;
    font-size: 16px;
    color: ${props => props.theme.services4u.text};
    padding-top: 14px;
    line-height: 24px;
    height: 68px;
    text-overflow: ellipsis;
    overflow: hidden;
    word-wrap: break-word;
    overflow-wrap: break-word;

    ${customMedia.lessThan('md')`
        width: 209px;
        height: 90px;
        letter-spacing: -0.7px;
        text-overflow: ellipsis;
    `}

    ${customMedia.lessThan('xs')`
        width: 185px;
        height: 90px;
        letter-spacing: -0.7px;
        text-overflow: ellipsis;
    `}


`
export const KnowMoreContainer = styled.div`
    display: flex;
`
export const KnowMore = styled.p`
    font-size: 14px;
    color: ${props => props.theme.services4u.textMore};
    padding-top: 18px;
    display: flex;
`
export const SVG = styled.div`
    padding-top: 20px;
    padding-left: 5px;
`
export const ClickLink = styled.a`
    text-decoration: none;
    padding-right: 20px;
`